import router from '../router/router';
import AuthService from '../services/auth.service';

function isAuthRoute(route) {
  return route.name && ['login'].indexOf(route.name) !== -1;
}

export default {
  namespaced: true,
  state: {
    isAuthenticated: null,
    redirectToRoute: null,
  },
  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload;
    },
    redirectToRoute(state, redirectToRoute) {
      state.redirectToRoute = redirectToRoute;
    },
  },
  actions: {
    init({ commit }, route) {
      if (route && 'token' in route.query) {
        AuthService.setToken({ data: route.query }, 'token');
      }
      commit('isAuthenticated', AuthService.isAuthenticated());
    },
    login(store, user) {
      return AuthService.login(user);
    },
    signup(store, user) {
      return AuthService.register(user);
    },
    authSuccess({ commit, dispatch, state }, payload) {
      commit('isAuthenticated', payload.isAuthenticated);
      if (state.redirectToRoute) {
        router.push(state.redirectToRoute);
      } else {
        router.push({
          name: 'orders',
          params: { orderType: 'purchase' },
        });
      }
      dispatch('init', router.currentRoute, { root: true });
    },
    logout({ commit }) {
      commit('isAuthenticated', false);

      if (!isAuthRoute(router.currentRoute)) {
        AuthService.logout();
        router.push('/login');
      }
    },
    dashboardGuard({ state, commit }, to) {
      if (!state.isAuthenticated) {
        if (!isAuthRoute(to)) {
          commit('redirectToRoute', to.fullPath);
        }
        router.push('/login');
      }
    },
    loginGuard({ state }) {
      if (state.isAuthenticated) {
        router.push({
          name: 'orders',
          params: { orderType: 'purchase' },
        });
      }
    },
    unauthorized({ commit, dispatch }) {
      if (!isAuthRoute(router.currentRoute)) {
        commit('redirectToRoute', router.currentRoute.name);
      }
      dispatch('logout');
    },
  },
};
